// Import utilities
import { onReady, getFormFields } from '@automator/utilities';

// Invoke classes when the DOM is ready
onReady( () => {
	new UnsavedForms();
} );

/**
 * Warns users about unsaved changes on forms
 */
class UnsavedForms {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		this.createInstances();
	}

	/**
	 * Listen the submission of all forms on the page
	 *
	 * @return {undefined}
	 */
	createInstances() {
		// Iterate forms
		this.$forms.forEach( ( $form ) => {
			new UnsavedForm( $form );
		} );
	}

	/**
	 * Defines the attribute used to detect forms that should warn users
	 * about unsaved changes
	 *
	 * @return {String} The attribute
	 */
	get formUnsavedAttribute() {
		return 'warn-unsaved';
	}

	/**
	 * Returns all forms on the page that should warn users of unsaved changes
	 */
	get $forms() {
		return document.querySelectorAll( `form[${this.formUnsavedAttribute}]` );
	}
}

/**
 * Warns users about unsaved changes on a form
 */
class UnsavedForm {
	// eslint-disable-next-line require-jsdoc
	constructor( $form ) {
		// Save the form
		this.$form = $form;

		// Get initial field values
		this.originalValues = getFormFields( this.$form );

		// Listen to the user leaving the page
		this.listenUserLeaving();

		// Listen form submission
		this.listenFormSubmission();
	}

	/**
	 * Listens to the user leaving the page
	 *
	 * @return {undefined}
	 */
	listenUserLeaving() {
		window.addEventListener( 'beforeunload', ( event ) => {
			// Get the field values
			const fieldValues = getFormFields( this.$form );

			// Compare current values with the original ones
			// We're going to convert both objects to JSON because we know the order will be the same
			// If it's not the same, we can assume something changed. However, this could be improved
			// in the future with the Underscore's or Lodash's isEqual function
			if (
				JSON.stringify( this.originalValues ) != JSON.stringify( fieldValues ) &&
				// Make sure the user is not leaving the page because of the form submission
				! this.submittingForm
			) {
				// Cancel the event as stated by the standard.
				event.preventDefault();

				// Chrome requires returnValue to be set.
				event.returnValue = UncannyAutomatorBackend.i18n.notSaved;

				return UncannyAutomatorBackend.i18n.notSaved;
			}
		} );
	}

	/**
	 * Listens the form submission. We will use this to avoid showing the "unsaved changes"
	 * alert if the user is leaving the page because of the submission
	 *
	 * @return {undefined}
	 */
	listenFormSubmission() {
		this.$form.addEventListener( 'submit', () => {
			this.submittingForm = true;
		} );
	}
}
